interface ArticleImageProps extends React.HTMLAttributes<HTMLImageElement> {
  image: string;
  env: any;
  taxonomyId: string;
}

const taxonomyDefaultImages = {
  '0': 'noimage',
  '1': 'dunger',
  '2': 'dunger',
  '3': 'dunger',
  '4': 'dunger',
  '5': 'noimage',
  '6': 'noimage',
  '7': 'dunger',
  '8': 'noimage',
  '9': 'noimage',
  '10': 'noimage',
  '11': 'noimage',
  '12': 'dunger',
  '13': 'dunger',
  '14': 'dunger',
  '15': 'dunger',
  '16': 'dunger',
  '17': 'dunger',
  '18': 'dunger',
  '19': 'dunger',
  '20': 'dunger',
  '21': 'noimage',
  '22': 'noimage',
  '23': 'PSM',
  '24': 'PSM',
  '25': 'PSM',
  '26': 'PSM',
  '27': 'PSM',
  '28': 'PSM',
  '29': 'PSM',
  '30': 'PSM',
  '31': 'PSM',
  '32': 'seed',
  '33': 'noimage',
  '34': 'noimage',
  '35': 'noimage',
  '36': 'PSM',
  '37': 'PSM',
  '38': 'PSM',
  '39': 'PSM',
  '40': 'PSM',
  '41': 'PSM',
  '42': 'PSM',
  '43': 'PSM',
  '44': 'noimage',
  '45': null,
  '46': null,
  '47': 'seed',
  '48': 'seed',
  '49': 'seed',
  '50': 'seed',
  '51': 'seed',
  '52': 'seed',
  '53': 'seed',
};

function getItemImage(image: string) {
  return `/catalogue/images/${encodeURIComponent(image)}`;
}

function getDefaultImage(taxonomyId: string | null): string {
  if (!taxonomyId) return '';

  const taxonomyImage: string =
    (taxonomyId &&
      taxonomyDefaultImages[
        taxonomyId as keyof typeof taxonomyDefaultImages
      ]) ||
    'noimage';
  return `/catalogue/noimage/${taxonomyImage || 'noimage'}`;
}

const ArticleImage = (props: ArticleImageProps) => {
  const { image, env, taxonomyId, ...rest } = props;

  const staticUrl = env.VITE_STATIC_URL;

  const path = image ? getItemImage(image) : getDefaultImage(taxonomyId);

  return <img src={`${staticUrl}${path}.webp`} {...rest} />;
};

export default ArticleImage;
